// extracted by css-extract-rspack-plugin
export default {"fullScreenLoader":"fullScreenLoader-rqPPW6"};